import { ajaxCall } from "@/shared/connection/ajax-call";
import { handleErrorByMessage } from "@/shared/connection/with-store-error-handlers";
import { Theme } from "@/shared/themes/Theme.interface";
import { PageSection } from "@/apps/page/page.interfaces";

const ENDPOINT = "/pages";

export const pageSectionsService = {
    exchangeFieldData({
        uuid,
        sectionId,
        fieldName,
        itemId,
        fieldValue,
        theme,
        fullSection,
    }: {
        uuid: string;
        sectionId: string;
        fieldName: string;
        itemId?: string;
        fieldValue: Record<string, unknown>;
        theme: Theme;
        fullSection?: PageSection;
    }) {
        return ajaxCall
            .patch(`${ENDPOINT}/${uuid}/exchange`, {
                sectionId,
                name: fieldName,
                itemId,
                fieldValue,
                theme,
                fullSection,
            })
            .catch(handleErrorByMessage());
    },
};
